import { ComponentType } from 'react';
import { LocationsList } from './locations-list';

export const Locations: ComponentType = () => {
  return <LocationsList />;
};
